import React from 'react';
import { useNavigation } from '../contexts/NavigationProvider';
import { useMessaging } from '../contexts/MessagingProvider';
import { useNotifications } from '../contexts/NotificationsProvider';
import HomeIcon from './icons/HomeIcon';
import BellIcon from './icons/BellIcon';
import ChatBubbleIcon from './icons/ChatBubbleIcon';
// FIX: Imported the missing UsersIcon component.
import UsersIcon from './icons/UsersIcon';

interface BottomNavBarProps {
  isFixed?: boolean;
}

const BottomNavBar: React.FC<BottomNavBarProps> = ({ isFixed = true }) => {
  const { view, handleNavigation } = useNavigation();
  const { unreadMessagesCount } = useMessaging();
  const { unreadNotificationsCount } = useNotifications();
  
  const baseClasses = "md:hidden bg-brand-surface border-t border-gray-700 px-2 flex justify-around items-center";
  const layoutClasses = isFixed
    ? "fixed bottom-0 left-0 right-0"
    : "flex-shrink-0";

  return (
    <nav className={`${baseClasses} ${layoutClasses}`}>
      <NavItem icon={<HomeIcon className="h-6 w-6" />} label="Home" active={view === 'feed'} onClick={() => handleNavigation('feed')} />
      <NavItem icon={<ChatBubbleIcon className="h-6 w-6" />} label="Messages" active={view === 'messages'} onClick={() => handleNavigation('messages')} badgeCount={unreadMessagesCount} />
      <button
        onClick={() => handleNavigation('createOpportunity')}
        aria-label="Post Opportunity"
        className="h-16 w-16 rounded-full shadow-lg -mt-8 flex-shrink-0 bg-brand-orange flex items-center justify-center p-3"
      >
        <img src="/icon.png" alt="Post opportunity" className="w-full h-full object-contain" />
      </button>
      <NavItem icon={<BellIcon className="h-6 w-6" />} label="Alerts" active={view === 'notifications'} onClick={() => handleNavigation('notifications')} badgeCount={unreadNotificationsCount} />
      <NavItem icon={<UsersIcon className="h-6 w-6" />} label="Network" active={view === 'network'} onClick={() => handleNavigation('network')} />
    </nav>
  );
};

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
  badgeCount?: number;
}

const NavItem: React.FC<NavItemProps> = ({ icon, label, active, onClick, badgeCount }) => (
  <button
    onClick={onClick}
    className={`relative flex flex-col items-center justify-center space-y-1 w-1/4 py-2 transition-colors ${
      active ? 'text-brand-orange' : 'text-brand-muted'
    } hover:text-white`}
  >
    {icon}
    <span className="text-xs">{label}</span>
    {badgeCount && badgeCount > 0 && (
        <span className="absolute top-0 right-2 block h-4 w-4 rounded-full bg-brand-orange text-white text-xs font-semibold flex items-center justify-center">
             {badgeCount > 9 ? '9+' : badgeCount}
        </span>
    )}
  </button>
);


export default BottomNavBar;